import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchLocation } from "@/lib/api";
import { LOCATIONS } from "@/data/locations";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [locationKey, setLocationKey] = useState("colonnade");

  useEffect(() => {
    fetchLocation().then((d) => setLocationKey(d.active || "colonnade")).catch(() => {});
  }, []);

  const location = LOCATIONS[locationKey] || LOCATIONS.colonnade;
  return <SiteContext.Provider value={{ location, locationKey, setLocationKey }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
